/**
 * La visita tracciata (`tpSessionId`), per chi deve agganciarle qualcosa
 * dopo il caricamento. La scrive `TpSessionHandler`: l'id del cookie se
 * c'era, quello nuovo quando init ha risposto, null se init è fallito (e
 * allora non c'è una visita a cui agganciare niente).
 *
 * Serve alle pagine che scoprono un codice invito solo dopo una chiamata,
 * come /convenzioni/{slug}: il codice non è nell'URL, quindi la cattura di
 * `TpSessionHandler` non lo vede, e per un visitatore nuovo il cookie
 * arriva solo dopo la risposta di init.
 */
let resolveVisit: (tpSessionId: string | null) => void = () => {};

export const visitReady: Promise<string | null> = new Promise(resolve => {
  resolveVisit = resolve;
});

export function markVisitReady(tpSessionId: string | null) {
  resolveVisit(tpSessionId);
}
